<div
  class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-space-between"
>
  <h5 class="mb-0 d-flex align-items-center">
    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <span>Escala</span>
  </h5>
  <ol class="breadcrumb mb-0 ps-0">
    <li class="breadcrumb-item">
      <a routerLink="/">
        <i class="ri-home-8-line"></i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item gray-color">Escala</li>
    <li class="breadcrumb-item fw-semibold">Visualização</li>
  </ol>
</div>

<mat-card appearance="outlined" class="mb-25 tagus-card">
  <mat-card-content>
    <div class="row mt-5 pt-5">
      <div class="col-12">
        <full-calendar [options]="calendarOptions"> </full-calendar>
      </div>
    </div>
  </mat-card-content>
</mat-card>
